export default __webpack_public_path__ + "static/media/omer.d7b19f10.png";